import React from "react";
import DayNamesContainer from "./DayNamesContainer";
import SomedayBackdrop from "./SomedayBackdrop";
import { MemoizedMonths } from "shared/CalendarView/Months.shared";

export default class CalendarView extends React.Component {
  monthList() {
    return <MemoizedMonths {...this.props} />;
  }

  render() {
    const { dateHelper } = this.props;
    return (
      <div className="calendar-view-outer-wrapper">
        {this.props.disabled && <div className="grayed-out backdrop"></div>}
        <DayNamesContainer dateHelper={dateHelper} />
        {this.props.isSomeday && <SomedayBackdrop />}
        <div className="Calendar-view" id="Calendar-view">
          {this.monthList()}
        </div>
        {this.props.fixedIntervals}
      </div>
    );
  }
}


